import { LuPhone, LuMapPin } from "react-icons/lu";

export default function Footer() {
    return (
        <footer className="bg-lightBg dark:bg-charcoal border-t border-gold/20">
            <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-12">

                {/* Brand */}
                <div>
                    <h3 className="text-2xl font-serif text-gold">
                        M R Suites Dharwad
                    </h3>
                    <p className="mt-4 text-sm text-charcoal/70 dark:text-ivory/70 leading-relaxed">
                        A refined stay where heritage elegance meets modern comfort.
                        Thoughtfully designed for travellers seeking calm, comfort,
                        and timeless hospitality.
                    </p>
                </div>

                {/* Quick Links */}
                <div>
                    <h4 className="text-lg font-serif text-gold mb-4">
                        Quick Links
                    </h4>
                    <ul className="space-y-3 text-sm text-charcoal/70 dark:text-ivory/70">
                        <li><a href="/" className="hover:text-gold">Home</a></li>
                        <li><a href="/about" className="hover:text-gold">About</a></li>
                        <li><a href="#rooms" className="hover:text-gold">Rooms</a></li>
                        <li><a href="#gallery" className="hover:text-gold">Gallery</a></li>
                        <li><a href="#contact" className="hover:text-gold">Contact</a></li>
                    </ul>
                </div>

                {/* Contact */}
                <div>
                    <h4 className="text-lg font-serif text-gold mb-4">
                        Contact
                    </h4>
                    <p className="flex items-center gap-2 text-sm text-charcoal/70 dark:text-ivory/70">
                        <LuMapPin size={16} />  M R Suites Dharwad<br />
                        Kalburgi Building, P B Road<br />
                        Dharwad, Karnataka - 580008<br />
                    </p>

                    <p className="mt-3 flex items-center gap-2 text-sm text-charcoal/70 dark:text-ivory/70">
                        <LuPhone size={16} /> +91 7090628555
                    </p>

                    <a
                        href="https://wa.me/917090628555"
                        target="_blank"
                        rel="noreferrer"
                        className="inline-block mt-4 text-gold hover:underline"
                    >
                        WhatsApp Enquiry
                    </a>
                </div>

            </div>

            {/* Bottom Bar */}
            <div className="border-t border-gold/10 py-6 text-center text-sm text-charcoal/60 dark:text-ivory/60">
                © {new Date().getFullYear()} M R Suites Dharwad. All rights reserved.
            </div>
        </footer>
    );
}